import { graphql } from "react-relay";

export const UpdateNotificationRuleMutation = graphql`
  mutation UpdateNotificationRuleMutation(
    $input: UpdateNotificationRuleInput!
  ) {
    updateNotificationRule(input: $input) {
      notificationRule {
        description
        filterJSON
        groupBy
        id
        includeCostData
        name
        openGroupCount
        openResourceCount
        target {
          ... on NotificationRuleJiraTarget {
            assignee {
              type
              value
            }
            description
            instance {
              uuid
            }
            space {
              type
              value
            }
            workType
          }
        }
        updateSchedule
        uuid
      }
      problems {
        message
      }
    }
  }
`;
